import Vue from "vue";
import router from "@/router";
import axios from "axios";
import { store } from "@/store";

//创建axios实例
const service = axios.create({
  timeout: 30000, //超时时间
  withCredentials: true
});

//添加request拦截器
service.interceptors.request.use(
  config => {
    config.headers = {
      "Content-Type": "application/json", //  注意：设置很关键
      "token": store.state.userInfo.token ? store.state.userInfo.token : ""
    };
    return config;
  },
  error => {
    Promise.reject(error);
  }
);
//添加response拦截器
service.interceptors.response.use(
  response => {
    let res = {};
    res.status = response.status;
    res.data = response.data;
    // 405
    if (res.data.code == -1) {
      // localStorage.removeItem("userInfo");
      // store.commit("setUserInfo", {});
      // // store.commit('setMessage', res.message);
      // this.$Message.destroy();
      // this.$Message.error(res.data.desc);
      router.push({
        path: "/login"
      });
    }
    return res;
  },
  error => {
    if (error.response && error.response.status == 404) {
      //跳转到xx页面
      console.log("404错误");
    }
    if (error.response.code == -1) {
      console.log("405错误");
      // this.$Message.destroy();
      // this.$Message.error(response.data.message);
      router.push({
        path: "/login"
      });
    }
    return Promise.reject(error.response);
  }
);

//封装get接口
// params={} 是设置默认值
export function get(url, params = {}) {
  // params.t = new Date().getTime(); //get方法加一个时间参数,解决ie下可能缓存问题.
  return service({
    url: url,
    method: "get",
    headers: {},
    params
  });
}
//封装post请求
export function post(url, data = {}) {
  //默认配置
  let sendObject = {
    url: url,
    method: "post",
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: data
  };
  // sendObject.data = JSON.stringify(data);
  return service(sendObject);
}



// WEBPACK FOOTER //
// ./src/assets/axios.js